import {css, StyleSheet} from "aphrodite";
import React from 'react';
import GridStyles from "../styles/styles";
import Feature from "./Feature";
import MediaQuery from "../styles/MediaQuery";

const FeaturesArea = ({extraStyle, features}) => {
    const styles = StyleSheet.create({
        container: {
            ...GridStyles.define("max-content", "minmax(20px, auto) auto minmax(20px, auto)")
        },
        wrapper: {
            ...GridStyles.setRowCol(1, 2),
            ...GridStyles.define(`auto`, "auto"),
            gridRowGap: 51,
            justifyContent: "center",
            ...MediaQuery.mobile({
                gridRowGap: 48
            })
        },
        feature: {
            ...GridStyles.setCol(1),
            gridRow: "auto",
        }
    });

    return (
        <div id="features" className={css(styles.container, extraStyle)}>
            <div className={css(styles.wrapper)}>
                {Object.entries(features).map(([key, value], index) =>
                    <Feature index={index} extraStyle={styles.feature} key={value.title} feature={value}/>)
                }
            </div>
        </div>
    );
};

export default FeaturesArea;
